<!-- 绘画列表页 -->
<template>
  <div class="component-header">
    <div class="banner" v-loading="loading">
      <div class="detailtitle">{{ detail.basicTitle }}</div>
      <div class="detailimg">
        <!-- <img :src="detail.Cover" alt="" sizes="" srcset="" /> -->
        <div class="contents" v-html="detail.basicContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "@/api/datas";
import { listData } from "@/api/zjps";
export default {
  name: "ComponentHeader",
  data() {
    return {
      isphone: false,
      loading: false,
      detail: {},
      // 正式环境
      detailnum: 201
    };
  },
  mounted() {
    this.loading = true;
    // 获取数据列表
    listData(this.detailnum).then(res => {
      // 取数组的前1条
      var datas = res.slice(0, 1);
      this.detail = datas[0];
      this.loading = false;
    });
  },
  methods: {}
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* 暂无数据是的样式 */
.empty {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 120px 0;
  background-color: rgba(255, 255, 255, 0.5);
}
.component-header {
  position: relative;
  min-width: 1200px;
  padding-top: 200px;
}
.titlehang1 {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.active {
  background-color: var(--main-color);
  color: #fff;
}
.banner {
  width: 100%;
  font-family: "思源宋体";
  padding: 0 50px 500px 50px;
}
.banner .detailtitle {
  font-size: 48px;
  color: var(--main-color);
  line-height: 1.3em;
}
.banner .detailinfo {
  font-size: 18px;
  height: 18px;
  line-height: 18px;
  position: relative;
  top: 36px;
}
.banner .detailimg {
  position: relative;
  top: 100px;
}
.banner .detailimg img {
  width: 100%;
}
.banner .detailimg .contents {
  font-size: 22px;
  font-family: "思源宋体" !important;
  line-height: 1.8em;
  text-indent: 2em;
  text-align: justify;
}
.banner .toupiao {
  position: relative;
  width: 560px;
  top: 200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.banner .toupiao .newnums {
  width: 260px;
  height: 45px;
  font-size: 22px;
  font-family: "微软雅黑";
  line-height: 45px;
  text-align: center;
  float: left;
  border-radius: 5px;
  border: solid 2px #e5b7af;
}
.banner .toupiao .newnums .rtnums {
  color: var(--main-color);
  font-size: 25px;
  height: 25px;
  line-height: 25px;
  font-weight: 600;
}
.banner .toupiao .dotou {
  position: relative;
  background-color: aquamarine;
  height: 45px;
  width: 260px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background-color: var(--main-color);
  font-size: 28px;
  font-weight: 600;
  font-family: "思源黑体";
}
.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(109, 3, 4, 0.9);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/psdetail.vue